module.exports = __webpack_public_path__ + "img/Purple.2dc7eae0.png";